import { render, staticRenderFns } from "./ProfessionsComponent.vue?vue&type=template&id=26fff872&scoped=true"
import script from "./ProfessionsComponent.vue?vue&type=script&lang=ts"
export * from "./ProfessionsComponent.vue?vue&type=script&lang=ts"
import style0 from "./ProfessionsComponent.vue?vue&type=style&index=0&id=26fff872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fff872",
  null
  
)

export default component.exports